import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class ProviderShowModel extends ApiModel {
  static get path() {
    return '/backend/provider_shows/{?id}';
  }

  @computed
  get counter() {
    return this.get('counter', 0);
  }

  @computed
  get link() {
    return this.get('link');
  }

  @computed
  get providerIri() {
    return this.get('provider');
  }

  @computed
  get providerShowCategoryIri() {
    return this.get('providerShowCategory');
  }
}
